// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__Ty7hK","title":"NotFound_title__bWGbt","message":"NotFound_message__TQ8zj","button":"NotFound_button__odj3z"};